import React from 'react';
import { motion } from 'framer-motion';

const MissionVision = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-1 px-4 lg:px-0">
          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="p-12 md:p-20 bg-slate-50 relative group"
          >
            <div className="absolute top-0 right-0 p-8 text-6xl font-bold text-slate-100 italic group-hover:text-[#91756A]/10 transition-colors duration-500">
              01
            </div>
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Our Mission</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-[#4D4C4A] leading-tight mb-10 italic tracking-tighter">
              To redefine modern living by elevating the standards of comfort through integrated engineering solutions.
            </h3>
            <p className="text-slate-500 leading-relaxed text-lg">
              Through innovation, engineering expertise, and continuous improvement, we aim to deliver systems that 
              enhance the quality, efficiency, and sustainability of modern buildings.
            </p>
          </motion.div>

          {/* Vision */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="p-12 md:p-20 bg-[#4D4C4A] text-white relative group"
          >
            <div className="absolute top-0 right-0 p-8 text-6xl font-bold text-white/[0.03] italic group-hover:text-[#91756A]/20 transition-colors duration-500">
              02
            </div>
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Our Vision</h2>
            <h3 className="text-3xl md:text-4xl font-bold leading-tight mb-10 italic tracking-tighter">
              To become the premier provider of integrated building solutions, shaping the future of infrastructure.
            </h3>
            <p className="text-white/60 leading-relaxed text-lg">
              To shape the future of infrastructure by delivering engineering solutions that combine 
              innovation, efficiency, and advanced technology, where every structure we contribute to 
              becomes a benchmark for excellence.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;